import { ISelectOptions } from './form/select';
import { IClassroomAssignmentDTO } from './student-assignment';

export interface IGetGradingPeriodRequestDTO {
  teacherId?: string;
  studentId?: string;
  classroomId: string;
}

export class GetGradingPeriodRequestDTO implements IGetGradingPeriodRequestDTO {
  teacherId?: string = '';
  studentId?: string = '';
  classroomId: string = '';
  constructor(configOverride?: Partial<IGetGradingPeriodRequestDTO>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export interface IGradingPeriodDTO {
  id: string;
  gradingPeriodTitle: string;
  fromDate: string;
  toDate: string;
  gradingType: GradingType;
  assignments?: IClassroomAssignmentDTO[];
}

export interface ICreateGradingPeriodRequestDTO {
  classroomId: string;
  gradingPeriodTitle: string;
  fromDate: string;
  toDate: string;
  gradingType: GradingType;
}

export interface IUpdateGradingPeriodRequestDTO {
  id: string;
  classroomId: string;
  gradingPeriodTitle: string;
  fromDate: string;
  toDate: string;
  gradingType: GradingType;
}

export class UpdateGradingPeriodRequestDTO
  implements IUpdateGradingPeriodRequestDTO
{
  id: string = '';
  classroomId: string = '';
  gradingPeriodTitle: string = '';
  fromDate: string = '';
  toDate: string = '';
  gradingType: GradingType = null;

  constructor(configOverride?: Partial<IUpdateGradingPeriodRequestDTO>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}
export enum GradingType {
  RUBRIC = 'RUBRIC',
  SCORE = 'SCORE',
}

export const gradingTypes: ISelectOptions[] = [
  { name: '', value: null },
  { name: 'Score as % (Often used in Grade 4-6)', value: GradingType.SCORE },
  {
    name: 'Mastery/Rubric (Often used in Grade K-3',
    value: GradingType.RUBRIC,
  },
];
export class CreateGradingPeriodRequestDTO
  implements ICreateGradingPeriodRequestDTO
{
  id: string = '';
  classroomId: string = '';
  gradingPeriodTitle: string = '';
  fromDate: string = '';
  toDate: string = '';
  gradingType: GradingType = null;

  constructor(configOverride?: Partial<ICreateGradingPeriodRequestDTO>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export class GradingPeriodDTO implements IGradingPeriodDTO {
  id: string = '';
  classroomId: string = '';
  gradingPeriodTitle: string = '';
  fromDate: string = '';
  toDate: string = '';
  gradingType: GradingType;
  assignments?: IClassroomAssignmentDTO[];

  constructor(configOverride?: Partial<IGradingPeriodDTO>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}
